/* ===========================================================================
   Black Betty BBQ - the unified gallery
   Tabs and lightbox. No dependencies, no build step.

   The markup renders every panel. A one-line inline script next to the markup
   sets data-bb-tabbed during parse (so there is no flash of all four panels),
   and this file wires the tabs, the URL and the lightbox on top. With
   JavaScript off, all four panels stay on the page, headed and readable.
   =========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function initGallery(root) {
    var tabs   = root.querySelectorAll('.bb-gallery__tab');
    var panels = root.querySelectorAll('.bb-gallery__panel');
    if (!tabs.length) return;

    root.setAttribute('data-bb-tabbed', '');

    // The tab roles go on here rather than in the markup: with no JavaScript
    // these are four ordinary links to four ordinary pages, and saying "tab"
    // to a screen reader when nothing can switch would be a lie.
    root.querySelector('.bb-gallery__tabs').setAttribute('role', 'tablist');
    each(tabs, function (tab) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', 'bb-panel-' + tab.getAttribute('data-bb-tab'));
    });
    each(panels, function (panel) {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'bb-tab-' + panel.getAttribute('data-bb-panel'));
      panel.setAttribute('tabindex', '0');
    });

    function show(id, push) {
      var found = false;
      each(panels, function (panel) {
        var match = panel.getAttribute('data-bb-panel') === id;
        panel.hidden = !match;
        if (match) found = true;
      });
      if (!found) return false;
      each(tabs, function (tab) {
        var match = tab.getAttribute('data-bb-tab') === id;
        tab.setAttribute('aria-selected', match ? 'true' : 'false');
        tab.setAttribute('tabindex', match ? '0' : '-1');
      });
      var current = root.querySelector('.bb-gallery__tab[data-bb-tab="' + id + '"]');
      if (push) {
        try { history.pushState({ bbTab: id }, '', current.href); } catch (e) {}
      }
      // The strip scrolls sideways on a phone; keep the open tab in view.
      if (current.scrollIntoView) {
        current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      return true;
    }

    each(tabs, function (tab, i) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        show(tab.getAttribute('data-bb-tab'), true);
        root.querySelector('.bb-gallery__tabs').scrollIntoView({ block: 'nearest' });
      });
      // Left/right walk the tab strip, which is what a tablist is meant to do.
      tab.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        next.focus();
        show(next.getAttribute('data-bb-tab'), true);
      });
    });

    window.addEventListener('popstate', function () {
      var here = location.pathname.split('/').pop();
      each(tabs, function (tab) {
        if (tab.getAttribute('href').split('/').pop() === here) {
          show(tab.getAttribute('data-bb-tab'), false);
        }
      });
    });

    show(root.getAttribute('data-bb-initial') || tabs[0].getAttribute('data-bb-tab'), false);
    return show;
  }

  /* --- the lightbox --------------------------------------------------------
     One overlay, reused. The list of photos is whichever panel is open, so
     prev/next never wander into another gallery. */
  function initLightbox(root) {
    var box = document.createElement('div');
    box.className = 'bb-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Photo viewer');
    box.innerHTML =
      '<button type="button" class="bb-lightbox__btn bb-lightbox__btn--close" aria-label="Close">&times;</button>' +
      '<button type="button" class="bb-lightbox__btn bb-lightbox__btn--prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="bb-lightbox__btn bb-lightbox__btn--next" aria-label="Next photo">&#8250;</button>' +
      '<div class="bb-lightbox__stage">' +
        '<figure class="bb-lightbox__figure"><img class="bb-lightbox__img" alt=""></figure>' +
      '</div>' +
      '<div class="bb-lightbox__bar">' +
        '<figcaption class="bb-lightbox__caption" aria-live="polite">' +
          '<span class="bb-lightbox__text"></span>' +
          '<span class="bb-lightbox__count"></span>' +
        '</figcaption>' +
        '<div class="bb-lightbox__thumbs" role="tablist" aria-label="Photographs"></div>' +
        '<p class="bb-lightbox__hint">&larr; &rarr; to move &middot; Esc to close</p>' +
      '</div>';
    document.body.appendChild(box);

    var img    = box.querySelector('.bb-lightbox__img');
    var text   = box.querySelector('.bb-lightbox__text');
    var count  = box.querySelector('.bb-lightbox__count');
    var strip  = box.querySelector('.bb-lightbox__thumbs');
    var prevBt = box.querySelector('.bb-lightbox__btn--prev');
    var nextBt = box.querySelector('.bb-lightbox__btn--next');
    var items  = [];
    var thumbs = [];
    var index  = 0;
    var opener = null;

    // Fetching the neighbours while you look at this one: by the time the
    // arrow is pressed the next photograph is already in cache.
    function preload(i) {
      var btn = items[i];
      if (!btn) return;
      var pre = new Image();
      pre.src = btn.getAttribute('data-bb-full');
    }

    function buildStrip() {
      strip.innerHTML = '';
      thumbs = items.map(function (btn, i) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'bb-lightbox__thumb';
        t.setAttribute('aria-label', 'Photo ' + (i + 1) + ': ' + btn.getAttribute('data-bb-caption'));
        var im = document.createElement('img');
        im.src = btn.querySelector('img').src;
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        t.appendChild(im);
        t.addEventListener('click', function () { go(i); });
        strip.appendChild(t);
        return t;
      });
    }

    function paint() {
      var btn = items[index];
      img.setAttribute('data-bb-loading', '');
      img.src = btn.getAttribute('data-bb-full');
      img.width = btn.getAttribute('data-bb-w');
      img.height = btn.getAttribute('data-bb-h');
      img.alt = btn.querySelector('img').alt;
      text.textContent = btn.getAttribute('data-bb-caption');
      count.textContent = (index + 1) + ' of ' + items.length;

      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      });
      preload(index + 1);
      preload(index - 1);
    }

    img.addEventListener('load', function () { img.removeAttribute('data-bb-loading'); });

    function go(i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      paint();
    }
    function step(by) {
      if (items.length < 2) return;
      go(index + by);
    }

    function open(btn) {
      var panel = btn.closest('.bb-gallery__panel');
      items = Array.prototype.slice.call(panel.querySelectorAll('.bb-gallery__open'));
      index = items.indexOf(btn);
      opener = btn;
      buildStrip();
      var solo = items.length < 2;
      prevBt.hidden = solo;
      nextBt.hidden = solo;
      strip.hidden = solo;
      paint();
      box.hidden = false;
      document.body.classList.add('bb-lightbox-open');
      box.querySelector('.bb-lightbox__btn--close').focus();
    }

    function close() {
      box.hidden = true;
      document.body.classList.remove('bb-lightbox-open');
      if (opener) opener.focus();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bb-gallery__open');
      if (btn) { e.preventDefault(); open(btn); }
    });

    box.querySelector('.bb-lightbox__btn--close').addEventListener('click', close);
    prevBt.addEventListener('click', function () { step(-1); });
    nextBt.addEventListener('click', function () { step(1); });
    // Clicking the picture moves on; clicking the darkness closes.
    img.addEventListener('click', function () { step(1); });
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('bb-lightbox__stage')) close();
    });

    // Swipe, for the phone. Horizontal only, so a vertical scroll of the
    // thumbnail strip is never mistaken for a page turn.
    var startX = 0, startY = 0, tracking = false;
    box.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.bb-lightbox__thumbs') || e.target.closest('button')) return;
      tracking = true; startX = e.clientX; startY = e.clientY;
    });
    box.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    });
    box.addEventListener('pointercancel', function () { tracking = false; });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(items.length - 1); }
      else if (e.key === 'Tab') {
        // Keep the tab ring inside the dialog while it is open.
        var focusable = Array.prototype.filter.call(
          box.querySelectorAll('button'), function (b) { return !b.hidden && b.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }


  ready(function () {
    var root = document.querySelector('.bb-gallery');
    if (!root) return;
    initGallery(root);
    initLightbox(root);
  });
})();
